module.exports = __webpack_public_path__ + "gatsby.b43c86.svg";